import http from '../utils/http';

export function jobList(data) {
  return http.post('hidream_jobs', data);
}

export function jobDetail(data) {
  return http.post('job_detail', data);
}

const jobApi = { jobList, jobDetail };

export default jobApi;
